import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

// ─── Cancel a downsell scheduled for the next billing date ───────────────────

interface CancelPlanChangePayload {
  /** Internal subscription document ID */
  subscription_id: string;
  /** Firestore company ID */
  company_id: string;
  /** Company API key for security validation */
  company_api_key: string;
}

interface CancelPlanChangeResponse {
  subscription_id: string;
  /** The plan the subscription stays on */
  id_plan: string;
  /** The plan that was scheduled and is now dropped */
  cancelled_plan_id: string;
}

/**
 * Cancel a scheduled downgrade. Possible as long as the next billing date has not
 * been reached — the subscription simply stays on its current plan.
 */
export async function cancelPlanChange(
  payload: CancelPlanChangePayload,
  auth: Authentication,
): Promise<CancelPlanChangeResponse> {
  try {
    const { company_api_key, ...body } = payload;
    const response = await HttpClient.post(
      '/leedflow/stripe/subscription/cancel-plan-change',
      body,
      auth.token,
      false,
      {
        'x-api-key': company_api_key,
        'x-user-uid': auth.id,
      },
    );

    return response.data;
  } catch (e) {
    console.error('cancelPlanChange error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new CancelPlanChangeFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new CancelPlanChangeFailure(e.message);
    }
    return Promise.reject(e);
  }
}

// ─── Failure class ───────────────────────────────────────────────────────────

export class CancelPlanChangeFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
